import React from 'react';

import AirtelMap from '../AirtelMap';
import { Map, GoogleApiWrapper } from 'google-maps-react';
import isEqual from 'lodash/isEqual';
import MapControls from '../MapControls/MapControls';
import MarkerCluster from '../MarkerCluster/MarkerCluster';
import MapLegend from '../MapLegend/MapLegend';
import MapOrders from '../MapOrders/MapOrders';

import apiKey from '../constants';

import mapStyles from '../Styles/countryStyles.json';

class CountryMap extends AirtelMap {
  static defaultProps = {
    clusters: [],
    styles: mapStyles,
    zoom: 2,
    minZoom: 3
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.center !== prevState.initialCenter) {
      return {
        initialCenter: nextProps.center
      };
    }

    return null;
  }

  renderOrders = () => {
    const { activeOrder, showingInfoWindow } = this.state;
    const { orders, tooltipContent, google, map } = this.props;
    const markerCollection = [];

    return orders.map((order, i) => {
      let preventRenderOrigin = false;
      let preventRenderDestination = false;

      preventRenderOrigin = markerCollection.some(originMarker => {
        return isEqual(order.origin, originMarker);
      });

      preventRenderDestination = markerCollection.some(destinationMarker => {
        return isEqual(order.destination, destinationMarker);
      });

      if (!preventRenderOrigin) {
        markerCollection.push(order.origin);
      }

      if (!preventRenderDestination && !order.destination.nr) {
        markerCollection.push(order.destination);
      }

      return (
        <MapOrders
          configured={order.configured}
          google={google}
          handleClick={this.handleOrderClick}
          handleMouseout={this.handleOrderMouseOut}
          handleMouseover={this.handleOrderMouseHover}
          key={`order-${i}`}
          map={map}
          order={order}
          orderId={i}
          preventRenderDestination={preventRenderDestination}
          preventRenderOrigin={preventRenderOrigin}
          selected={(activeOrder === i) && showingInfoWindow}
          tooltipContent={tooltipContent}
          virtualDestination={!!order.destination.nr}
        />
      );
    });
  }

  render() {
    const { initialCenter, currentCenter, satellite } = this.state;

    const {
      zoom,
      google,
      withLegend,
      styles,
      clusters,
      orders,
      ...rest
    } = this.props;

    return (
      <Map
        center={currentCenter}
        disableDefaultUI
        disableDoubleClickZoom
        initialCenter={initialCenter}
        google={google}
        styles={styles}
        onDragend={this.centerMoved}
        zoom={zoom}
        ref={this.mapRef}
        onClick={this.handleMapClicked}
        scrollwheel={false}
        {...rest}
      >
        {
          clusters.map((cluster, i) => (
              <MarkerCluster
                title={cluster.title}
                label={cluster.label}
                position={cluster.position}
                key={`cluster-${i}`}
                isCluster
              />
            )
          )
        }
        {
          withLegend &&
            <MapLegend icon={{ name: 'pop-cluster', type: '20' }} />
        }
        {orders && this.renderOrders()}
        <MapControls
          satellite={satellite}
          clickCenter={this.handleClickCenter}
          clickZoomIn={this.handleClickZoomIn}
          clickZoomOut={this.handleClickZoomOut}
          clickMapType={this.handleClickMapType}
        />
      </Map>
    );
  }
}

export default GoogleApiWrapper({ apiKey })(CountryMap);



// WEBPACK FOOTER //
// ./src/uis/components/Map/CountryMap/CountryMap.js